<template>
	<div class="order_card">
		<div @click="$emit('click')">
			<text-item class="mb-28" :label="`订单编号：${ orderId }`">
				<span class="text-danger" v-if="status == 0">待支付</span>
				<span class="text-primary" v-else-if="status == 3">已完成</span>
				<span class="text-gray" v-else-if="status == 88">交易关闭</span>
				<span class="text-gray" v-else>{{ $status.orderStatus[status] }}</span>
			</text-item>

			<infor-card v-bind="$attrs" />
		</div>

		<div class="order_card__action van-hairline--top mt-40 pt-28 text-right" v-if="status == 0 || status == 3">
			<van-button type="primary" size="small" v-if="status == 0" @click="$emit('pay')">支付</van-button>
			<van-button type="primary" plain size="small" v-if="status == 3" @click="$emit('report')">查看报告</van-button>
		</div>
		<div class="order_card__desc van-hairline--top mt-40 pt-28" v-if="status == 99">
			<p>关闭原因：<span class="text-danger">{{ message }}</span></p>
		</div>
	</div>
</template>

<script>
export default {
	name: "order-card",
	props: {
		orderId: {
			type: [String, Number],
			default: ''
		},
		status: {
			type: [String, Number],
			default: ''
		},
		message: {
			type: String,
			default: ''
		}
	}
};
</script>

<style scoped lang="less">
	.order_card {
		padding: 32px 28px;
		border-radius: 16px;
		background-color: #fff;
		&__desc {
			font-family: PingFangSC-Regular;
			font-size: 30px;
			line-height: 34px;
			color: #1F2329;
		}
	}
</style>

